import $ from 'jquery'

$(document).ready(function() {
  dhsv_vc_econtribute_structure()
})

function dhsv_vc_econtribute_structure() {
  $('.dhsv_vc_econtribute_structure').each(function() {
    const $toggler = $(this).find('.js-persons_toggle')
    $toggler.on('click', function() {
      $(this)
        .toggleClass('opened')
        .siblings('.persons__list')
        .slideToggle()
        .parent()
        .toggleClass('opened')
    })
  })
}
